import { isToolbarStripeActive } from './ToolbarStore';

export const updateToolbarStripe = (value) => isToolbarStripeActive.update((oldValue) => value);
